import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService } from 'app/services';
import { PdfImageUploaderComponent } from './../pdf-image-uploader/pdf-image-uploader.component';

@Component({
  selector: 'app-pdf-logo-template',
  templateUrl: './pdf-logo-template.component.html',
  styleUrls: ['./pdf-logo-template.component.scss'],
})
export class PdfLogoTemplateComponent implements OnInit {
  routeSubscription: any;
  template: any = {};
  user: any = {};
  previewImage: string = '';
  updatedAt: string = '';
  pdfImage: string = '';
  isUploading: boolean = false;
  isEditable: boolean = false;
  _user: any = {};
  logoFile: any = null;
  imageType: any = null;
  company: any = { address: {} };

  constructor(private route: ActivatedRoute, private httpService: HTTPService, private helperService: HelperService, private dialogService: DialogService) {}

  ngOnInit() {
    this.routeSubscription = this.route.data.subscribe((data) => {
      this.template = data;
    });
    this.getCompany();
  }

  getCompany() {
    this.httpService.getUpdateLocationSettings(['pdfLogoFormatType']).then(
      (location: any) => {
        this.company = location;
        this.previewImage = location.pdfLogo;
        this.updatedAt = location.updatedAt;

        if (location?.appsettings) {
          this.imageType = location.appsettings.pdfLogoFormatType;
        }

        if (location?.address) {
          const { addLine1, city, stateCode, country, zip } = location?.address;
          const addressArr = [addLine1 || '', city || '', stateCode || '', country || '', zip || ''];

          this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleFileUpload(event: any) {
    const [file] = event.target.files;
    this.logoFile = file;
    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (pdfEvent: any) => {
        this.pdfImage = pdfEvent.currentTarget.result;
        this.openImageCropperDialog(file, this.pdfImage);
      };
    }
  }

  openImageCropperDialog(file: any, pdfImage: any) {
    const ref = this.dialogService.open(PdfImageUploaderComponent, {
      width: '60%',
      styleClass: 'small-heading-dialog pdf-image-uploader',
      showHeader: false,
      data: { file, src: pdfImage },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        let file: any;

        if (data.imageType === 'stretch' || data.imageType === 'bestFit') {
          file = this.logoFile;
        } else {
          file = this.helperService.dataURLtoBlob(data.image);
        }

        this.imageType = data.imageType;
        this.isEditable = true;
        this.isUploading = true;

        const formData = new FormData();
        formData.append('file', file);

        this.httpService.uploadCompanyLogo(formData).then(
          (url) => {
            this.isUploading = false;
            this.previewImage = url.url;
            this.user.image = url.url;
            this.httpService.updateLocationSettings({ pdfLogo: url.url, pdfLogoKey: url.key, settings: { pdfLogoFormatType: this.imageType } }).then(
              (res) => {
                this.helperService.showToaster('success', 'Company Updated');
              },
              (err) => {
                this.helperService.showToaster('error', err);
              }
            );
          },
          (err) => {
            this.isUploading = false;
            this.helperService.showToaster('error', err);
          }
        );
      }

      onClose.unsubscribe();
    });
  }

  clearLogo() {
    this.isEditable = true;
    this.isUploading = true;
    this.previewImage = '';
    this.user.image = '';
    this.httpService.updateLocationSettings({ pdfLogo: '', pdpLogoKey: '', settings: { pdfLogoFormatType: null } }).then(
      (res) => {
        this.isEditable = true;
        this.isUploading = true;
        this.helperService.showToaster('success', 'Company Updated');
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }
}
